import {useQuery} from 'react-query'
import {VerticalEditModalForm} from './VerticalEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
// import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
import { getVerticalById } from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const VerticalEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: vertical,
    error,
  } = useQuery(
    `${QUERIES.VERTICALS_LIST}-vertical-${itemIdForUpdate}`,
    () => {
      return getVerticalById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <VerticalEditModalForm isVerticalLoading={isLoading} vertical={{id: undefined}} />
  }

  if (!isLoading && !error && vertical) {
    return <VerticalEditModalForm isVerticalLoading={isLoading} vertical={vertical} />
  }

  return null
}

export {VerticalEditModalFormWrapper}
